import * as types from "./types"
import http from "@/utils/http"
import http_pay from "@/utils/http_pay"
// 轻提示
import { Toast } from 'vant';

let state = {
    noData: false,
    carList: [],
    queryVehicles: [],
    inputIsShow: false,
    parkList: [],
    monthlyList: [],
    rentTime: "无月租记录",
    belongMerberCarStr: "请选择车辆",
    belongParkStr: "请选择停车场",
    belongParkId: "",
    belongCarFixedId: "",
    endTime: "",
    carTypeCode: "",
    startTime: '',
    ownerName: '',
    parkingGroupId: '',
    parkNum: '',
    note: '',
    ownerTel: '',
    rent: '',
    parkingGroupName: '',
}
// 异步任务
let actions = {
    [types.MONTHLYLENHTHQUERY](context, params) { // 包月时长列表
        http.post('p-ypt-monthlyLength-query', params).then(data => {
            context.commit(types.MONTHLYLENHTHQUERY, data)
        })
    },
    [types.QUERYVEHICLES](context, params) { // 我的车辆列表
      http_pay.post('p-ypt-query-vehicles-on-site', params).then(data => {
        context.commit(types.QUERYVEHICLES, data)
      })
    },
    /** 月租缴费 */
    [types.MERBERCARPUBLICQUERY](context, params) { // 我的车辆列表
      http_pay.post('p-ypt-merberCarPublic-query', params).then(data => {
            context.commit(types.MERBERCARPUBLICQUERY, data)
        })
    },
    [types.MONTHPAYADD](context, params) { // 提交月租缴费订单
        http.post('p-ypt-monthPay-add', params).then(data => {
            context.commit(types.MONTHPAYADD, data)
        })
    },
    // [types.PARKINGPAYQUERY](context, params) { // 月租缴费-停车场列表
    //     http.post('p-ypt-parkingPay-query', params).then(data => {
    //         context.commit(types.PARKINGPAYQUERY, data)
    //     })
    // },
    // [types.PARKINGHOTELQUERY](context, params) { // 月租缴费-停车场列表
    //     http.post('p-ypt-parking-hotel-query', params).then(data => {
    //         context.commit(types.PARKINGHOTELQUERY, data)
    //     })
    // },
    [types.OEDERQUERY](context, params) { // 获取订单号
        http.post('p-ypt-orderNo-query', params).then(data => {
            context.commit(types.OEDERQUERY, data)
        })
    },
    [types.MONTHRENTTIME](context, params) { // 车辆对应停车场的月租期限
        http.post('p-ypt-getMonthRentTime-query', params).then(data => {
            context.commit(types.MONTHRENTTIME, data)
        })
    },
}
// 同步任务
let mutations = {
    [types.MONTHLYLENHTHQUERY](state, data) {
        if (data.code==='ok') {
            state.monthlyList = data.data
        } else {
            Toast(data.message)
        }
    },
    [types.QUERYVEHICLES](state, data) {
      if (data.code==='ok') {
        state.inputIsShow = true
        if (data.data.length >= 1) {
          state.queryVehicles = data.data
        } else {
          state.noData = true
        }
      } else {
        Toast(data.message)
      }
    },
    /** 月租缴费 */
    [types.MERBERCARPUBLICQUERY](state, data) {
        if (data.code==='ok') {
            if (data.data.length >= 1) {
                state.carList = data.data
            } else {
                state.noData = true
            }
        } else {
            Toast(data.message)
        }
    },
    [types.MONTHPAYADD](state, data) {
        if (data.code==='ok') {
        } else {
            Toast(data.message)
        }
    },
    [types.PARKINGPAYQUERY](state, data) {
        if (data.code==='ok') {
            state.parkList = data.data
        } else {
            Toast(data.message)
        }
    },
    // [types.PARKINGHOTELQUERY](state, data) {
    //     if (data.code==='ok') {
    //         state.parkList = data.data
    //     } else {
    //         Toast(data.message)
    //     }
    // },
    [types.MONTHRENTTIME](state, data) { //车辆对应停车场的月租期限
        if (data.code==='ok') {
            state.rentTime = data.data.monthRentTime
        } else {
            Toast(data.message)
        }
    },
    MONTNRENTRESET(state, data) {
        state.carList = [],
            state.parkList = [],
            state.monthlyList = [],
            state.noData = false,
            state.rentTime = "无月租记录"
    },
    // 选择停车场
    setParkInfo(state, data) {
        state.belongParkStr = data.belongParkStr
        state.belongParkId = data.belongParkId
    },
    // 选择车牌
    setCarInfo(state, data) {
        state.belongMerberCarStr = data.carNo
    },
    RESETMONTHDATA(state) {
        state.belongParkStr = '请选择停车场'
        state.belongMerberCarStr = '请选择车辆'
        state.belongParkId = ''
    },
    // 设置 月租 websocket回传数据
    setMonthData(state, data) {
        if (data.hasOwnProperty('rentList')) { // 包月时长
            state.monthlyList = data.rentList
        }
        state.rentTime = data.startTime.substring(0, 10) + '~' + data.endTime.substring(0, 10)
        state.belongCarFixedId = data.id
        state.endTime = data.endTime
        state.startTime = data.startTime
        state.monthlyRent = data.monthlyRent
    },
    // 重置 月租 websocket数据
    resetMonthData(state, data) {
        state.monthlyList = []
        state.rentTime = '无月租记录'
        state.belongCarFixedId = ''
        state.endTime = ''
        state.carTypeCode = ''
        state.startTime = ''
        state.ownerName = ''
        state.parkingGroupId = ''
        state.parkNum = ''
        state.note = ''
        state.ownerTel = ''
        state.rent = ''
        state.parkingGroupName = ''
    }
}

export default { state, actions, mutations }



// WEBPACK FOOTER //
// ./src/store/month/index.js